var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { IssueBox } from "./IssueBox";
import { MonthBand } from "./MonthBand";
import { SpecialIssuesBand } from "./SpecialIssuesBand";
import { computeMergedEndDates, formatDateLabel, formatDateRange, } from "../../utils/issueDateFormat";
import { computeMonthlyStats } from "../../utils/issueMonthStats";
import { placeIssues } from "../../utils/issueLayoutPlacement";
import { monthKeyOf } from "../../utils/volumeWindow";
import css from "./IssueLayoutTier2.module.css";
export var IssueLayoutTier2 = function (_a) {
    var issues = _a.issues, onIssueClick = _a.onIssueClick, onLinkedVolumeClick = _a.onLinkedVolumeClick;
    var stats = useMemo(function () { return computeMonthlyStats(issues); }, [issues]);
    var mergedEndDates = useMemo(function () { return computeMergedEndDates(issues); }, [issues]);
    var placement = useMemo(function () { return placeIssues(issues); }, [issues]);
    var issuesByMonth = useMemo(function () {
        var map = new Map();
        placement.dated.forEach(function (iss) {
            var _a;
            var _b;
            var key = monthKeyOf(iss.expectedDate).key;
            if (!map.has(key))
                map.set(key, []);
            (_a = map
                .get(key))
                .push.apply(_a, __spreadArray([iss], ((_b = placement.followersByParentId.get(iss.id)) !== null && _b !== void 0 ? _b : []), false));
        });
        return map;
    }, [placement]);
    return (React.createElement("div", null,
        Array.from(stats.values()).map(function (month) {
            var _a;
            return (React.createElement(React.Fragment, { key: month.key },
                React.createElement(MonthBand, { month: month.month, year: month.year, received: month.received, expected: month.expected }),
                React.createElement("div", { className: css.row }, ((_a = issuesByMonth.get(month.key)) !== null && _a !== void 0 ? _a : []).map(function (iss) {
                    var endIso = mergedEndDates.get(iss.id);
                    var dateLabel = endIso
                        ? formatDateRange(iss.expectedDate, endIso, 2)
                        : formatDateLabel(iss.expectedDate, 2);
                    return (React.createElement(IssueBox, { key: iss.id, issue: iss, onClick: onIssueClick, onLinkedVolumeClick: onLinkedVolumeClick, dateLabel: dateLabel }));
                }))));
        }),
        React.createElement(SpecialIssuesBand, { issues: placement.unplaced, onIssueClick: onIssueClick, onLinkedVolumeClick: onLinkedVolumeClick })));
};
